const url = process.env.VUE_APP_BACK_SERVER_URL;
export default url;
